import { Options } from "api/interfaces";
import { Entity } from "interfaces/entities";
import { Text } from "iparque-components";
import { AppContext } from "providers/AppProvider";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import {
  Container,
  ResponsiveContainer,
  StyledArrow,
  StyledImage,
  TextContainer,
} from "./styles";

interface Props {
  entity: Entity;
  authToken: string;
  onClick: (entity: Entity, authToken: string, options: Options) => void;
}

const EntityItem: React.FC<Props> = ({ entity, authToken, onClick }) => {
  const theme = useTheme();
  const { setIsLoading } = useContext(AppContext);
  const { t } = useTranslation();

  const localOnClick = async () => {
    setIsLoading(true);

    await onClick(entity, authToken, {
      t,
      stopLoading: () => setIsLoading(false),
    });
  };

  return (
    <Container className="mb-15" onClick={localOnClick}>
      <ResponsiveContainer>
        <StyledImage src={entity.logoUrl} />
        <TextContainer>
          <Text variant="body6">{entity.description}</Text>
        </TextContainer>
      </ResponsiveContainer>
      <StyledArrow className="arrow" fill={theme.colors.primary} />
    </Container>
  );
};

export default EntityItem;
